import MockMode from "./MockMode";
import Submission from "./Submission";
import SearchDialog from "./search/SearchDialog";
import DefaultLoader from "components/common/DefaultLoader";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";
import * as staticDataService from "services/staticDataService";
import * as companyActions from "store/actions/company/companyActions";
import * as exposureActions from "store/actions/input/exposure/exposureActions";
import * as staticDataActions from "store/actions/temp/staticData/staticDataActions";

const useTempStoreConfig = (keys) => {
  // TODO: Remove this once we no longer acccess config via the temp store.
  //
  // This is retrieving a list config and saving it to the the temp store. For new
  // use-cases, using the staticDataService directly is the preferred approach. But
  // there are some legacy use-cases (notably new & renewed submissions) that rely
  // on it being in the temp store. This hook populates that.

  const dispatch = useDispatch();

  const { data, isLoading } = staticDataService.useMultiConfigQuery(keys);

  useEffect(() => {
    dispatch(staticDataActions.retrieveConfig.succeeded(data));
  }, [dispatch, data]);

  return { isLoading };
};

const SubmissionApp = ({
  source = "submissions",
  isMockMode,
  isSubmissionLoading,
  loadAllExposureMetrics,
  loadAllIndustryClasses,
  loadAllLossCategories,
  checkCategoryCodes,
  retrieveValidClaimsFileFormats,
  retrieveInflationModelConfig,
  retrieveAnalyticsConfig,
  retrieveSovTortCaps,
}) => {
  const { isLoading: isConfigLoading } = useTempStoreConfig([
    "claims_files",
    "flags",
    "pricing_assumptions",
    "reinsurers",
    "scenarios",
    "submission_defaults",
    "translations",
    "underwriters",
    "general_configuration",
    "renewal",
    "feature_flags",
  ]);

  useEffect(() => {
    loadAllExposureMetrics();
    loadAllIndustryClasses();
    loadAllLossCategories();
    checkCategoryCodes();
    retrieveValidClaimsFileFormats();
    retrieveInflationModelConfig();
    retrieveAnalyticsConfig();
    retrieveSovTortCaps();
  }, [
    loadAllExposureMetrics,
    loadAllIndustryClasses,
    loadAllLossCategories,
    checkCategoryCodes,
    retrieveValidClaimsFileFormats,
    retrieveInflationModelConfig,
    retrieveAnalyticsConfig,
    retrieveSovTortCaps,
  ]);

  return (
    <>
      {isMockMode && <MockMode />}
      {isSubmissionLoading || isConfigLoading ? (
        <DefaultLoader
          size={100}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      ) : (
        <Routes>
          <Route
            path={":submissionId/version/:versionId/*"}
            element={<Submission source={source} />}
          />
          <Route
            path={":submissionId/*"}
            element={<Submission source={source} />}
          />
          {source === "submissions" && (
            <Route path={"/"} element={<SearchDialog />} replace />
          )}
        </Routes>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isMockMode: state.isMockStore,
    isSubmissionLoading: state.persistence?.isLoading ?? false,
  };
};

const mapDispatchToProps = {
  loadAllExposureMetrics: exposureActions.loadAllExposureMetrics,
  loadAllIndustryClasses: exposureActions.loadAllIndustryClasses,
  loadAllLossCategories: exposureActions.loadAllLossCategories,
  checkCategoryCodes: companyActions.checkCategoryCodes,
  retrieveValidClaimsFileFormats:
    staticDataActions.retrieveValidClaimsFileFormats.requested,
  retrieveInflationModelConfig:
    staticDataActions.retrieveInflationModelConfig.requested,
  retrieveAnalyticsConfig: staticDataActions.retrieveAnalyticsConfig.requested,
  retrieveSovTortCaps: staticDataActions.retrieveSovTortCaps.requested,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionApp);
